<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-col cols="12" class="pa-3">
    <v-card>
      <v-card-title class="display-1">
        {{ root.getCurrentFormTitle() }}
        <slot name="titleTooltip"></slot>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          class="pa-0"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-row class="fill-height" no-gutters align="center">
          <v-btn
            small
            v-if="!disableEditionActions"
            v-on:click="onNewElement"
            color="primary"
            dark
            :id="'new-' + root.getCurrentFormType()"
            >New {{ root.getCurrentFormTitle() }}</v-btn
          >
          <v-menu
            bottom
            transition="scale-transition"
            offset-y
            v-if="
              !disableEditionActions && root.getCurrentFormTitle() !== 'Mission'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-1 pa-0 pl-2"
                color="indigo"
                outlined
                dark
                v-bind="attrs"
                v-on="on"
                small
                :disabled="demoUser"
                :id="'import-' + root.getCurrentFormType()"
              >
                IMPORT
                <v-icon dark class="ma-0">arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="
                  this.availableRoutesTableForDataImporter.includes(
                    this.root.getCurrentFormType()
                  )
                "
                v-on:click="dataImporterDialog = true"
              >
                <v-list-item-title>
                  Import from other modules
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="
                  !disableEditionActions &&
                  root.getCurrentFormTitle() !== 'Mission'
                "
                v-on:click="root.importDefaultData()"
              >
                <v-list-item-title> Import Default Data </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-on:click="importExportJsonFileDialog = true"
                v-if="
                  !disableEditionActions &&
                  root.getCurrentFormTitle() !== 'Mission'
                "
              >
                <v-list-item-title> Import/Export Json file </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-dialog width="700" v-model="dataImporterDialog">
            <data-importer :root="this" :disabled="demoUser"></data-importer>
          </v-dialog>
          <v-dialog scrollable width="550" v-model="importExportJsonFileDialog">
            <import-export-json-file :root="this" />
          </v-dialog>
          <v-dialog v-model="confirmDeleteDialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="demoUser"
                color="red lighten-1"
                class="ml-1 white--text"
                v-on="on"
                small
                outlined
                :id="'delete-all-' + root.getCurrentFormType()"
              >
                Delete all
              </v-btn>
            </template>

            <v-card>
              <v-card-title :style="backgroundStarStyle">
                <span class="headline black--text">Warning</span>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  small
                  class="m-0"
                  @click="confirmDeleteDialog = false"
                  :id="'close-delete-all-' + root.getCurrentFormType()"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="mt-3">
                Are you sure you want to delete all the items in this table?
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="confirmDeleteDialog = false"
                  v-on:click="root.removeAll()"
                  :id="'confirm-delete-all-' + root.getCurrentFormType()"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-dialog
          :max-width="formWidth + 'px'"
          persistent
          v-model="root.inputs.displayForm"
          :eager="eagerForm"
        >
          <slot></slot>
          <!-- Forms -->
        </v-dialog>
      </v-card-title>
      <v-data-table
        :headers="root.tableFields"
        :items="root.tableItems"
        :search="search"
        :footer-props="{ itemsPerPageOptions: rowsPerPageItems }"
        :options.sync="pagination"
        max-width="800"
      >
        <template slot="item" slot-scope="row">
          <tr>
            <td
              v-for="header in root.tableFields"
              :key="header.value"
              :class="classObject(row.item)"
            >
              <div v-if="isDateField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ formatDate(row.item[header.value]) }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isStringField(header.value)">
                <v-tooltip
                  v-if="
                    !row.item.homogeneousConstellationGeometries &&
                    row.item.typeName !=
                      'AnalyticalConstellationEarthZoneOfInterest'
                  "
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ row.item[header.value] }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
                <v-tooltip
                  v-else-if="
                    row.item.typeName ==
                    'AnalyticalConstellationEarthZoneOfInterest'
                  "
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ row.item[header.value] }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getCustomInfos(row.item)
                  }}</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ row.item[header.value] }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getConstellationInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isValueField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ root.displayRangeValue(row.item, header.value) }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isReferenceField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ root.displayRefValue(row.item, header.value) }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isEnumField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ root.displayEnumValue(row.item, header.value) }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isBooleanField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        :disabled="true"
                        v-model="row.item[header.value]"
                      ></v-checkbox>
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <div v-if="isCustomField(header.value)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ root.displayCustomValue(row.item, header.value) }}
                    </span>
                  </template>
                  <span style="margin: 0; padding: 0; white-space: pre-line">{{
                    root.getCustomInfos(row.item)
                  }}</span>
                </v-tooltip>
              </div>
              <v-row v-if="header.value === 'actions'">
                <v-tooltip top v-if="overviewAction">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'results-' + row.index"
                      icon
                      class="mx-0"
                      @click.stop="root.overview(row.item)"
                      v-on="on"
                    >
                      <v-icon color="#3f51b5">remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Results</span>
                </v-tooltip>
                <v-tooltip top v-if="!disableEditionActions">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'edit-' + row.index"
                      icon
                      class="mx-0"
                      @click.stop="root.edit(row.item, row.index)"
                      v-on="on"
                    >
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top v-if="!disableEditionActions">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'copy-' + row.index"
                      icon
                      class="mx-0"
                      @click.stop="root.copy(row.item)"
                      v-on="on"
                    >
                      <v-icon color="blue">file_copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy</span>
                </v-tooltip>
                <v-tooltip top v-if="enableShareAndArchive">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'share-' + row.index"
                      :disabled="demoUser"
                      icon
                      class="mx-0"
                      @click="showShareDialog(row.item)"
                      v-on="on"
                    >
                      <v-icon color="orange">share</v-icon>
                    </v-btn>
                  </template>
                  <span>Share</span>
                </v-tooltip>
                <v-tooltip top v-if="enableShareAndArchive">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'archive-' + row.index"
                      :disabled="demoUser"
                      icon
                      class="mx-0"
                      @click="archive(row.item)"
                      v-on="on"
                    >
                      <v-icon color="#9370DB">archive</v-icon>
                    </v-btn>
                  </template>
                  <span>Archive</span>
                </v-tooltip>
                <v-tooltip top v-if="enableUnarchiveDeleteActions">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'unarchive-' + row.index"
                      icon
                      class="mx-0"
                      @click="unarchive(row.item)"
                      v-on="on"
                    >
                      <v-icon color="#9370DB">unarchive</v-icon>
                    </v-btn>
                  </template>
                  <span>Unarchive</span>
                </v-tooltip>
                <v-tooltip top v-if="enableImportDeleteActions">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'import-' + row.index"
                      icon
                      class="mx-0"
                      @click="root.importData(row.item)"
                      v-on="on"
                    >
                      <v-icon color="blue">get_app</v-icon>
                    </v-btn>
                  </template>
                  <span>Import into your dashboard</span>
                </v-tooltip>
                <v-tooltip
                  top
                  v-if="
                    !disableEditionActions ||
                    enableUnarchiveDeleteActions ||
                    enableImportDeleteActions
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'delete-' + row.index"
                      icon
                      class="mx-0"
                      @click.stop="
                        root.removeIfNotUsedAsReference(
                          row.item,
                          row.index,
                          $event.target
                        )
                      "
                      v-on="on"
                    >
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-row>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="shareDialog" max-width="450">
      <v-card>
        <v-list>
          <v-subheader>SHARE WITH GROUP</v-subheader>
          <v-alert
            v-if="!filterGroups"
            class="ma-3"
            :value="true"
            color="info"
            icon="new_releases"
          >
            You seem to have no groups created. At least one group with one user
            is needed to share a mission.
          </v-alert>
          <v-list-item
            @click=";(groupToShare = group.id), (gName = group.groupName)"
            color="primary"
            v-for="group in filterGroups"
            :key="group.id"
            :class="{ 'selected-row': group.id === groupToShare }"
          >
            <div>
              <span v-text="group.groupName"></span>
            </div>
          </v-list-item>
        </v-list>
        <v-card-actions class="justify-end">
          <v-btn
            depressed
            v-if="!groupToShare"
            color="info"
            to="/groups"
            class="ml-3"
          >
            Create a new group
          </v-btn>
          <v-btn
            color="primary"
            @click="shareObject()"
            :disabled="!groupToShare || loaderNotif"
            :loading="loaderNotif"
            depressed
          >
            {{
              gName
                ? `Share with ${
                    gName.length > 10 ? gName.substring(0, 9) + '...' : gName
                  }`
                : 'Share'
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
import errorMixin from '../mixins/logHandler.js'
import DataImporter from './Table/DataImporter'
import ImportExportJsonFile from './Table/ImportExportJsonFile'

export default {
  name: 'exo-table',
  mixins: [errorMixin],
  props: {
    root: Object,
    formWidth: {
      type: Number,
      default: 1000
    },
    enableShareAndArchive: {
      type: Boolean,
      default: false
    },
    disableEditionActions: {
      type: Boolean,
      default: false
    },
    enableUnarchiveDeleteActions: {
      type: Boolean,
      default: false
    },
    enableImportDeleteActions: {
      type: Boolean,
      default: false
    },
    overviewAction: {
      type: Boolean,
      default: false
    },
    eagerForm: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'data-importer': DataImporter,
    'import-export-json-file': ImportExportJsonFile
  },
  data() {
    return {
      search: '',
      shareDialog: false,
      rowsPerPageItems: [25, 50, 100, { text: 'All', value: -1 }],
      pagination: {
        rowsPerPage: 25
      },
      tableItems: [],
      confirmDeleteDialog: false,
      groupToShare: null,
      gName: null,
      objectToShare: null,
      loaderNotif: false,
      importExportJsonFileDialog: false,
      availableRoutesTableForDataImporter: [
        'OrbitDefinition',
        'SpacecraftDefinition',
        'PropulsionSystemDefinition',
        'ParametricOrbitDefinition',
        'ParametricSpacecraftDefinition',
        'ParametricPropulsionSystemDefinition'
      ],
      dataImporterDialog: false
    }
  },
  mounted() {
    let self = this
    this.$el.addEventListener('webkitAnimationEnd', function () {
      self.root.successAlertMessage = ''
    })
    this.$root.$on('actualize-table-page', this.actualizeTablePageHandler)
  },

  beforeDestroy() {
    this.$root.$off('actualize-table-page', this.actualizeTablePageHandler)
  },

  computed: {
    ...mapGetters({ missions: 'missions', groups: 'groups' }),
    backgroundStarStyle() {
      return 'background: #3BE287'
    },
    filterGroups() {
      if (!this.groups) {
        return []
      }
      return this.groups.filter((group) => {
        return group.userRole === 'ADMIN'
      })
    },
    demoUser() {
      return this.currentUser == null || this.currentUser.type === 'demo'
    }
  },

  methods: {
    actualizeTablePageHandler(name) {
      let table = this.root.tableItems.slice()
      this.sortTableItems(table)
      let self = this
      table.filter(function (e) {
        if (e.displayedName === name) {
          self.pagination.page = Math.ceil(
            (table.indexOf(e) + 1) / self.pagination.rowsPerPage
          )
        }
      })
    },

    formatDate(value) {
      if (value == null) {
        return ''
      }
      if (!(typeof value === 'string' || value instanceof String)) {
        value = new Date(value).toISOString()
      }
      return value.split('.')[0].replace('T', ' ').replace('Z', ' ')
    },

    sortTableItems(table) {
      let sortBy = this.pagination.sortBy
      let descending = this.pagination.descending
      table.sort(function (a, b) {
        if (!descending) {
          return a[sortBy] === b[sortBy] ? 0 : a[sortBy] > b[sortBy] ? 1 : -1
        } else {
          return a[sortBy] === b[sortBy] ? 0 : a[sortBy] < b[sortBy] ? 1 : -1
        }
      })
    },

    showShareDialog(item) {
      this.shareDialog = true
      this.objectToShare = item
    },

    archive(item) {
      let self = this
      let objectName = item.name.trim()
      this.$http
        .post(
          '/users/' +
            this.currentUser.id +
            '/' +
            this.root.getCurrentFormAPI(item).toLowerCase() +
            '/archive',
          item
        )
        .then(async function () {
          self.displayMessage(
            objectName + ' archived successfully.',
            '',
            'notification',
            'success'
          )
          self.$root.$emit('update-mission-list')
        })
        .catch((e) => {
          self.displayMessage(
            'Error archiving ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.$root.$emit('update-mission-list')
        })
    },

    unarchive(item) {
      let self = this
      let objectName = item.name.trim()
      this.$http
        .post(
          '/users/' +
            this.currentUser.id +
            '/' +
            this.root.getCurrentFormAPI(item).toLowerCase() +
            '/unarchive',
          item
        )
        .then(async function () {
          self.displayMessage(
            objectName + ' unarchived successfully.',
            '',
            'notification',
            'success'
          )
          self.$root.$emit('update-mission-list')
        })
        .catch((e) => {
          self.displayMessage(
            'Error unarchiving ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.$root.$emit('update-mission-list')
        })
    },

    shareObject() {
      let self = this
      self.loaderNotif = true
      let objectName = this.objectToShare.name.trim()
      this.$http
        .post(
          '/users/' +
            this.currentUser.id +
            '/' +
            this.root.getCurrentFormAPI(this.objectToShare).toLowerCase() +
            '/exporttogroup/' +
            this.groupToShare,
          this.objectToShare
        )
        .then(async function (response) {
          self.shareDialog = false
          self.objectToShare = null
          self.root.clearForm()
          self.loaderNotif = false
          self.displayMessage(
            'Object ' + objectName + ' shared successfully.',
            '',
            'notification',
            'success'
          )
        })
        .catch((e) => {
          self.loaderNotif = false
          self.displayMessage(
            'Error sharing ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    onNewElement() {
      if (this.root.inputs.editing) {
        this.root.clearForm()
        this.root.editing = false
      }
      if (this.root.redirectToNewMissionPage) {
        this.root.redirectToNewMissionPage()
      } else {
        this.root.inputs.displayForm = true
      }
    },
    isStringField(column) {
      return (
        this.root.getStringFields().includes(column) &&
        !this.root.getEnumProperties()[column] &&
        !this.root.getBooleanFields().includes(column)
      )
    },

    isDateField(column) {
      return this.root.getDateFields().includes(column)
    },

    isEnumField(column) {
      return this.root.getEnumProperties()[column]
    },

    isValueField(column) {
      return (
        this.root.getValueFields().includes(column) &&
        !this.root.getStringFields().includes(column) &&
        !this.root.getBooleanFields().includes(column)
      )
    },

    isReferenceField(column) {
      return this.root.getReferenceFields().includes(column)
    },

    isBooleanField(column) {
      return this.root.getBooleanFields().includes(column)
    },

    isCustomField(column) {
      return this.root.getCustomFields().includes(column)
    },

    classObject(item) {
      if (this.$vuetify.theme.dark) {
        return {
          'blinkdiv-darkmode':
            item.name != null &&
            item.name !== '' &&
            item.name === this.root.successAlertMessage
        }
      } else {
        return {
          blinkdiv:
            item.name != null &&
            item.name !== '' &&
            item.name === this.root.successAlertMessage
        }
      }
    }
  }
}
</script>

<style scoped>
@keyframes greenWhiteFade {
  0% {
    background-color: #c8e6c9;
  }
  50% {
    background-color: #a5d6a7;
  }
}

@-webkit-keyframes greenWhiteFade {
  0% {
    background-color: #c8e6c9;
  }
  50% {
    background-color: #a5d6a7;
  }
}

.blinkdiv {
  animation-name: greenWhiteFade;
  animation-iteration-count: 1;
  animation-duration: 2s;
  -webkit-animation-name: greenWhiteFade;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-duration: 2s;
}

@keyframes greenWhiteFade-darkmode {
  0% {
    background-color: #00ff3710;
  }
  50% {
    background-color: #00ff1149;
  }
}

@-webkit-keyframes greenWhiteFade-darkmode {
  0% {
    background-color: #00ff3710;
  }
  50% {
    background-color: #00ff1149;
  }
}

.blinkdiv-darkmode {
  animation-name: greenWhiteFade-darkmode;
  animation-iteration-count: 1;
  animation-duration: 2s;
  -webkit-animation-name: greenWhiteFade-darkmode;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-duration: 2s;
}

.vertical-align {
  position: relative;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}

.selected-row {
  background-color: #bbdefb;
}
.selected-row v-list-item-title {
  color: #1565c0;
}
</style>
